import { useMemo } from 'react';
import { useGetFavoritesGames, useGetUserCountry } from 'react-easyrocket';
import { useLocation } from 'react-router';
import { EVENT_GAME_CATEGORY } from 'src/config/event/eventConfig';
import { isShowEvent } from 'src/config/event/utils';
import { gamesList, jackpotSwitcherGamesList } from 'src/constants/gameCategories';

/**
 * ### useGetGamesList

Хук `useGetGamesList` возвращает отфильтрованный список категорий игр для сайдбара и свитчера категорий.

 - если у пользователя нет игр добавленных в __FAVORITES__ - эта категория не отображается
 - если пользователь заходит с ГЕО __РУМЫНИИ__ или __АВСТРАЛИИ__ - не отображаем категорию __Drops & Wins__
 */

const AVAILABLE_PRAGMATIC_COUNRTY = [
  'BEL',
  'CHE',
  'NLD',
  'PRT',
  'AUT',
  'DEU',
  'ESP',
  'FIN',
  'IRL',
  'POL',
  'NOR'
];

export const useGetGamesList = () => {
  const { games: favoriteGames } = useGetFavoritesGames();
  const { pathname } = useLocation();
  const { userCountry, isAUS } = useGetUserCountry();
  const country = userCountry?.country;
  const inROU = country === 'ROU';
  const hasfavoriteGames = favoriteGames.length !== 0;
  const isJackpotPath = pathname.includes('jackpot');

  return useMemo(() => {
    if (isJackpotPath) {
      return jackpotSwitcherGamesList;
    }
    return gamesList.filter((category) => {
      if (category.param === 'favorites') {
        return hasfavoriteGames;
      }
      if (category.param === 'dropwinscat') {
        return inROU || isAUS;
      }
      if (category.param === EVENT_GAME_CATEGORY) {
        return isShowEvent('GAME_CATEGORY');
      }
      if (category.param === 'pragmatic_play') {
        return AVAILABLE_PRAGMATIC_COUNRTY.includes(country);
      }
      return true;
    });
  }, [country, hasfavoriteGames, inROU, isAUS, isJackpotPath]);
};
